import { popoverAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers(popoverAnatomy.keys);

const baseStyle = definePartsStyle({
    // Avoid the original slow animation. Snapiness is king. (*♡∀♡)
    content: {
        transform: 'none !important',
        transition: 'none !important',
        opacity: '1 !important',
    },
});

const themedPopover = defineMultiStyleConfig({ baseStyle });

export default themedPopover;
